export default __webpack_public_path__ + "static/media/client_info_mail_icon.68886a54.svg";